import styled from 'styled-components';
import { RouterLink, RouterLinkProps } from '@redux-first-router-link';
import { Button } from '@simplywallst/ui-core';

export const DesktopTopbarLoggedOutWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  /* Button text can be arbitrarily long, usually we would want this to expand to its entire width, but in the nav */
  /* this causes overflow issues. This can be removed if nav responsiveness better handles arbitrary-length text (e.g. from i18n) */
  ${Button} {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;

export const NavItem = styled(RouterLink)<RouterLinkProps>`
  height: ${({ theme }) => theme.x8space * 10}px;
  line-height: ${({ theme }) => (theme.x8space - 0.2) * 10}px;
  padding: 0 ${({ theme }) => theme.x2spacePx}px;
  display: inline-block;
`;
